var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'core', 'app-common/component/service-call', 'model/categorizer-rule', 'template/reconciliation/categorizer-view.htm', 'app-common/lib/jquery.velocity', 'app-common/lib/jquery.flexselect'], function($, _, _s, Backbone, core, serviceCall, CategorizerRule, categorizerViewTemplate) {
  var CategorizerView;
  return CategorizerView = (function(_super) {

    __extends(CategorizerView, _super);

    function CategorizerView() {
      CategorizerView.__super__.constructor.apply(this, arguments);
    }

    CategorizerView.prototype.className = 'categorizer-view';

    CategorizerView.prototype.events = {
      'click .categorizer-view__edit-toggle:not(.disabled)': 'confirmRule',
      'click .categorizer-view__delete-toggle': 'deleteRule',
      'click .categorizer-view__close-toggle': 'hide',
      'click .categorizer-view__icon-button': 'clickChild',
      'input #keywordInput': 'validateInput',
      'input #priorityInput': 'validateInput',
      'input #minAmount': 'validateInput',
      'input #maxAmount': 'validateInput'
    };

    CategorizerView.prototype.initialize = function() {
      CategorizerView.__super__.initialize.apply(this, arguments);
      this.clientId = core.getCurrentClientId();
      this.ledgerSelect = this.prepareLedgerControl();
      return this.initHotkeys();
    };

    CategorizerView.prototype.initHotkeys = function() {
      var _this = this;
      $(document).off('keydown.categorizer-view');
      return $(document).on('keydown.categorizer-view', function(e) {
        if (_this.isVisible() && (e.which || e.keyCode) === 83 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          return _this.$el.find('.categorizer-view__edit-toggle').click();
        }
      });
    };

    CategorizerView.prototype.render = function(rule, notification) {
      var defaultLedgerId, ledgerSelect,
        _this = this;
      this.rule = rule;
      defaultLedgerId = rule.get('ledgerId');
      this.$el.html(_.template(categorizerViewTemplate, {
        clientId: this.clientId,
        rule: (rule != null) && rule.attributes,
        notification: notification
      }));
      ledgerSelect = this.ledgerSelect.clone();
      ledgerSelect.attr('id', 'categorizer-view-select');
      ledgerSelect.attr('data-default-value', defaultLedgerId);
      ledgerSelect.val(ledgerSelect.data('default-value'));
      this.$el.find('.categorizer-view__select__dropdown').append(ledgerSelect);
      ledgerSelect.flexselect({
        sortAlphabetically: true
      });
      this.$el.find('#categorizer-view-select').change(function() {
        return _this.validateInput();
      });
      return this.validateInput();
    };

    CategorizerView.prototype.prepareLedgerControl = function() {
      var select, selectableLedgerAccounts,
        _this = this;
      selectableLedgerAccounts = core.getCollection('ledgerAccounts').filter(function(account) {
        return account.isEditable();
      });
      select = $('<select/>').addClass('ledger-combobox');
      selectableLedgerAccounts.forEach(function(ledger) {
        var option;
        option = $('<option/>').attr('value', ledger.get('id')).text(_s.trim(ledger.get('name')));
        return select.append(option);
      });
      return select;
    };

    CategorizerView.prototype.hide = function() {
      this.trigger('categorizer.view.hidden');
      return this.$el.parent().velocity('stop').velocity('transition.slideRightOut', {
        duration: 100,
        queue: false
      });
    };

    CategorizerView.prototype.show = function(rule) {
      if (this.rule != null) {
        this.restoreUneditedStateTo(this.rule);
      }
      rule = rule != null ? rule : new CategorizerRule();
      this.saveUneditedStateAs(rule);
      this.render(rule);
      return this.$el.parent().velocity('stop').velocity('transition.slideRightIn', {
        duration: 500,
        queue: false
      });
    };

    CategorizerView.prototype.validateInput = function() {
      var ledgerId, maxAmount, minAmount, priority;
      ledgerId = this.$el.find('#categorizer-view-select').val();
      priority = this.$el.find('#priorityInput').val();
      minAmount = this.$el.find('#minAmount').val();
      maxAmount = this.$el.find('#maxAmount').val();
      this.rule.set({
        clientId: Number(this.clientId),
        ledgerId: !_.isEmpty(ledgerId) ? Number(ledgerId) : void 0,
        priority: !_.isEmpty(priority) ? Number(priority) : void 0,
        vendorContains: this.$el.find('#keywordInput').val(),
        minAmount: !_.isEmpty(minAmount) ? Number(minAmount) : void 0,
        maxAmount: !_.isEmpty(maxAmount) ? Number(maxAmount) : void 0
      });
      if (this.rule.isValid() && this.hasBeenEdited(this.rule)) {
        return this.enableAddRule();
      } else {
        return this.disableAddRule();
      }
    };

    CategorizerView.prototype.confirmRule = function() {
      var isNew, promise,
        _this = this;
      isNew = this.rule.isNew();
      promise = this.rule.save();
      promise.success(function() {
        var message;
        _this.saveUneditedStateAs(_this.rule);
        message = isNew ? 'Rule added successfully!' : 'Rule edited successfully!';
        _this.rule.clear().set(_this.rule.defaults);
        _this.trigger('categorizer.rule.changed');
        return _this.render(_this.rule, _this.successNotification(message));
      });
      return promise.fail(function() {
        var message;
        message = isNew ? 'Rule creation failed. Try again later.' : 'Rule edit failed. Try again later.';
        return _this.render(_this.rule, _this.failureNotification(message));
      });
    };

    CategorizerView.prototype.deleteRule = function() {
      var promise,
        _this = this;
      promise = this.rule.destroy({
        wait: true
      });
      promise.success(function() {
        _this.trigger('categorizer.rule.changed');
        return _this.render(new CategorizerRule(), _this.successNotification('Rule deleted successfully!'));
      });
      return promise.fail(function() {
        _this.restoreUneditedStateTo(_this.rule);
        return _this.render(_this.rule, _this.failureNotification('Rule deletion failed. Try again later.'));
      });
    };

    CategorizerView.prototype.disableAddRule = function() {
      this.$el.find('.categorizer-view__icon-button--save').addClass('disabled');
      return this.$el.find('.categorizer-view__icon-button--save').children().addClass('disabled');
    };

    CategorizerView.prototype.enableAddRule = function() {
      this.$el.find('.categorizer-view__icon-button--save').removeClass('disabled');
      return this.$el.find('.categorizer-view__icon-button--save').children().removeClass('disabled');
    };

    CategorizerView.prototype.successNotification = function(msg) {
      return {
        status: 'success',
        text: msg
      };
    };

    CategorizerView.prototype.failureNotification = function(msg) {
      return {
        status: 'failure',
        text: msg
      };
    };

    CategorizerView.prototype.restoreUneditedStateTo = function(rule) {
      return rule.set(this.uneditedRuleAttributes);
    };

    CategorizerView.prototype.saveUneditedStateAs = function(rule) {
      return this.uneditedRuleAttributes = _.extend({}, rule.attributes);
    };

    CategorizerView.prototype.hasBeenEdited = function(rule) {
      return !_.isEqual(this.uneditedRuleAttributes, rule.attributes);
    };

    CategorizerView.prototype.isDisplayingRule = function(ruleId) {
      return (this.rule != null) && this.rule.get('id') === ruleId;
    };

    CategorizerView.prototype.isDisplayingNewRule = function() {
      return this.rule.get('priority') == null;
    };

    CategorizerView.prototype.isVisible = function() {
      return this.$el.is(':visible');
    };

    CategorizerView.prototype.clickChild = function(e) {
      if (e.target !== e.currentTarget) {
        return;
      }
      return $(e.currentTarget).find('.control').click();
    };

    return CategorizerView;

  })(Backbone.View);
});
